<template>
    <div>
        <!--breadcrumbs area start-->
        <div class="breadcrumbs_area">
            <div class="container">   
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumb_content">
                            <ul>
                                <li><a href="/">Trang chủ</a></li>
                                <li>Đăng ký tài khoản</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>         
        </div>
        <!--breadcrumbs area end-->
        
        <!-- customer login start -->
        <div class="customer_login">
            <div class="container">
                <div class="row">
                <!--login area start-->
                    <div class="col-lg-6 col-md-6">
                        <div class="account_form">
                            <h2>Tạo tài khoản</h2>
                                <div class="form_group">
                                    <v-form ref="form_signup" v-model="valid" :autocomplete="autocomplete" style="border: none;">
                                        <p>   
                                            <label>Tài khoản<span>*</span></label>
                                            <v-text-field v-model="model.phone" :rules="usernameRules" required :autocomplete="autocomplete"></v-text-field>
                                        </p>
                                        <p>   
                                            <label>Họ tên<span>*</span></label>
                                            <v-text-field v-model="model.first_name" required :autocomplete="autocomplete"></v-text-field>
                                        </p>
                                        <p>   
                                            <label>Điện thoại<span>*</span></label>
                                            <v-text-field v-model="model.email" :rules="phoneRules" required :autocomplete="autocomplete"></v-text-field>
                                        </p>
                                        <p>   
                                            <label>Địa chỉ</label>
                                            <v-text-field v-model="model.address" :autocomplete="autocomplete"></v-text-field>
                                        </p>
                                        <p>   
                                            <label>Mật khẩu <span>*</span></label>
                                            <v-text-field type="password" :autocomplete="autocomplete" v-model="model.password" :rules="[v => !!v || 'Yêu cầu nhập mật khẩu', (model.password === re_type_password) || 'Mật khẩu chưa khớp']"></v-text-field>
                                        </p>
                                        <p>   
                                            <label>Xác nhận mật khẩu <span>*</span></label>
                                            <v-text-field type="password" :autocomplete="autocomplete" v-model="re_type_password" :rules="[v => !!v || 'Yêu cầu nhập mật khẩu', (model.password === re_type_password) || 'Mật khẩu chưa khớp']"></v-text-field>
                                        </p> 
                                    </v-form>
                                    <div class="login_submit">
                                        <button @click="register">Đăng ký</button>
                                    </div>
                                </div>
                        </div>    
                    </div>
                    <!--login area start-->
                </div>
            </div>    
        </div>
        <!-- customer login end -->
    </div>
</template>

<script>
import { sendErrorNotice } from '@/commons/utils'
export default {
    data: () => ({
        autocomplete: 'new-password',
        re_type_password: '',
        valid: false,
        phoneRules: [
            v => !!v || 'Hãy nhập số điện thoại',
            v => /^\d+$/.test(v) || 'Số điện thoại chỉ bao gồm các số 0-9',
            v => v.length === 10 || 'Số điện thoại có độ dài 10 chữ số'
        ],
        usernameRules: [
            v => !!v || 'Hãy nhập tên đăng nhập',
            v => v.length >= 3 || 'Tên đăng nhập tối thiểu có 3 ký tự',
            v => v.length <= 20 || 'Tên đăng nhập tối đa có 20 ký tự',
            v => /^[a-zA-Z0-9_]+$/.test(v) || 'Tên đăng nhập chỉ bao gồm chữ cái và chữ số.'
        ],
        model: {
            phone: '',
            first_name: '',
            email: '',
            address: '',
            password: ''
        }
    }),
    methods: {
        register() {
            if (!this.$refs.form_signup.validate()) {
                sendErrorNotice("Hãy kiểm tra lại dữ liệu đã nhập!");
                return;
            }
            this.$store.dispatch('users/signup', this.model).then(p => {
                this.$router.push('/dang-nhap');
            });
        }
    }
};
</script>